<template>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button class="button_back" @click="goBack">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title v-if="job.startDate">
      <template v-if="checkJobDateStart(job.startDate, job.endDate)">
        <span>{{ checkJobDateStart(job.startDate, job.endDate, true) }}</span> -
      </template>
      <span>{{ $moment(job.endDate, "YYYY/MM/DD").format("D MMM") }}</span>
    </ion-title>
  </ion-toolbar>

  <div class="main_wrapper ion-padding">
    <div class="container">
      <div class="job_info_wrapper" v-if="job.pharmacy">
          <div class="info-separator" />
        <div class="rate_shifts_info">
          <div class="info_wrapper d-flex align-items-center">
            <ClockIcon />
            <div class="info_title">Available shifts</div>
            <div class="info_value">
              <template v-if="checkJobDateStart(job.startDate, job.endDate)">
                <span>{{ checkJobDateStart(job.startDate, job.endDate) }}</span> -
              </template>
              <span>{{
                  $moment(job.endDate, "YYYY/MM/DD").format("D MMMM")
                }}</span>
            </div>
          </div>
        </div>
          <div class="rate_shifts_info">
            <div class="info_wrapper d-flex align-items-center">
            <LocationIcon />
            <div class="info_title">{{ $filters.addressText(job.pharmacy.address) }}</div>
          </div>
          </div>
        <div class="rate_shifts_info">
          <div class="info_wrapper d-flex align-items-center">
            <DollarWithCircleIcon />
            <div class="info_title"> Hourly rate (excluding super)</div>
            <div class="info_value ">
              $
              <span class="blur-price">rate</span>
            </div>
          </div>
        </div>
        <div class="info-separator mb-0" />
        <el-collapse accordion @change="handleChange">
          <el-collapse-item
              class="card-accordeon"
              title="More about the job"
              name="first"
          >
            <div class="collapse-list">
              <div v-if="job.settings.language" class="collapse-item">
                <span class="collapse-title">Language</span>
                <span class="collapse-value">{{ job.settings.language }}</span>
              </div>
              <div class="collapse-item">
                <span class="collapse-title">Solo Pharmacist</span>
                <span class="collapse-value">{{
                    job.settings.solo == 1 ? "Yes" : "No"}}</span>
              </div>
              <div class="collapse-item ">
                <span class="collapse-title"> {{ message.Immuniser }} req?</span>
                <span class="collapse-value">{{
                    job.covidCertRequired == 0
                        ? "Not Required"
                        : job.covidCertRequired == 1
                        ? "Mandatory"
                        : "Nice to Have"
                  }}</span>
              </div>
              <div class="collapse-item">
                <span class="collapse-title">Number of technicians</span>
                <span class="collapse-value">{{ job.settings.numOfTech }}</span>
              </div>
              <div class="collapse-item">
                <span class="collapse-title">Paying for Travel{{job.settings.payingForTravel == 1 ? '(>50KM roundtrip)' : ''}}</span>
                <span class="collapse-value">{{
                    job.settings.payingForTravel == 0 ? 'No travel' :  job.settings.payingForTravel == 1 ? "Partial travel" : "Full travel"
                  }}</span>
              </div>
              <div class="collapse-item">
                <span class="collapse-title">Pay for Flights</span>
                <span class="collapse-value">{{
                  job.settings.payForFlights == 0 ? 'No' : 'Yes'
                }}</span>
              </div>
              <div class="collapse-item">
                <span class="collapse-title">Pay for Accomodation</span>
                <span class="collapse-value">{{
                  job.settings.payForAccomodation == 0 ? 'No' : 'Yes'
                }}</span>
              </div>
              <div class="collapse-item" v-if="isAustralia">
                <span class="collapse-title">Dosage Administration Aids</span>
                <span class="collapse-value">{{
                    job.settings.adminAids == 1 ? "Yes" : "No"
                  }}</span>
              </div>
              <div class="collapse-item">
                <span class="collapse-title">Open Pharmacy</span>
                <span class="collapse-value">{{
                    job.settings.openUp == 1 ? "Yes" : "No"
                  }}</span>
              </div>
              <div class="collapse-item">
                <span class="collapse-title">Close Pharmacy</span>
                <span class="collapse-value">{{
                    job.settings.close == 1 ? "Yes" : "No"
                  }}</span>
              </div>
              <div v-if="job.settings.notes" class="collapse-item">
                <span class="collapse-title">Notes</span>
                <span class="collapse-value">{{ job.settings.notes }}</span>
              </div>
              <div v-if="job.settings.parking" class="collapse-item">
                <span class="collapse-title">Parking</span>
                <span class="collapse-value">{{ job.settings.parking }}</span>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
        <div class="info-separator mt-0" />
      </div>
      <el-form
          class="job_shifts_wrapper full_page"
          :model="formsData.dayForm"
          :rules="formsData.dayForm.rules"
          :ref="(el) => (formsData.dayForm.ref = el)"
          :label-position="'top'"
          @submit.prevent="submit('dayForm')"
      >
        <div
            class="form_text"
            v-if="formsData.dayForm.jobShifts.value.length >= 2"
        >
          <div class="text_note">
            Deselect days you do not wish to work
          </div>
        </div>
        <div
            class="job_shifts_form_checkbox"
            v-for="(shift, i) in formsData.dayForm.jobShifts.value"
            :key="shift.date"
        >
          <el-form-item class="mb0" prop="jobShifts">
            <el-checkbox
                :disabled="shift.disabled"
                class="checkbox_w100"
                v-model="shift.checkboxValue"
                @change="checkboxValueChange"
            >
              <div
                  :class="shift.confirmedHours ? 'confirmedHours' : ''"
                  class="job_shift_text"
              >
                <div class="day_info">
                  <div class="day_name">
                    {{ $moment(shift.date, "YYYY/MM/DD").format("ddd") }},
                    {{
                      $moment(shift.date, "YYYY/MM/DD").format("D MMM, YYYY")
                    }}
                  </div>
                  <div class="day_time">
                    <span>{{
                        $moment(shift.startTime, "HH:mm").format("h:mm A")
                      }}</span>
                    -
                    <span>{{
                        $moment(shift.endTime, "HH:mm").format("h:mm A")
                      }}</span>
                  </div>
                </div>
                <div class="info-wrapper">
                  <div class="day_info_block">
                    <DollarWithCircleIcon />
                    <div class="day_name">Rate</div>
                    <div class="day_time">
                      <span class="blur-price">
                     $$$</span
                      >
                    </div>
                  </div>
                  <div class="day_info_block">
                    <DollarWithCircleIcon />
                    <div class="day_name">Hours</div>
                    <div class="day_time">
                      <span>
                        {{
                          confirmedHours(shift.confirmedHours, shift.startTime, shift.endTime)
                        }}</span
                      >
                    </div>
                  </div>
                  <div class="day_info_block">
                    <RoutingIcon />
                    <div class="day_name">Travel</div>
                    <div class="day_time">
                    <span class="blur-price">
                    $$$</span
                    >
                    </div>
                  </div>
                  <div class="day_info_block">
                    <DollarWithCircleIcon />

                    <div class="day_name">Sum</div>
                    <div class="day_time">
                      <span class="blur-price">
                    $$$</span
                      >
                    </div>
                  </div>
                  
                </div>
                </div>
            </el-checkbox>
            <template #error="{ error }">
              <div
                  class="error_list"
                  v-if="
                  error ||
                    (formsData.dayForm.jobShifts.errors &&
                      formsData.dayForm.jobShifts.errors[i])
                "
              >
                <div
                    class="el-form-item__error"
                    :class="
                    formsData.dayForm.jobShifts.errors &&
                    formsData.dayForm.jobShifts.errors[i]
                      ? ''
                      : 'form_error'
                  "
                >
                  <span
                      v-if="
                      error &&
                        !formsData.dayForm.jobShifts.errors &&
                        formsData.dayForm.jobShifts.value.length - 1 == i
                    "
                  >{{ error }}</span
                  >
                  <span
                      v-if="
                      formsData.dayForm.jobShifts.errors &&
                        formsData.dayForm.jobShifts.errors[i]
                    "
                  >{{ formsData.dayForm.jobShifts.errors[i].message }}</span
                  >
                </div>
              </div>
              <span v-else></span>
            </template>
          </el-form-item>
        </div>
        <el-form-item v-if="userData.role"  class="button_submit mb0">
          <el-button
              class="submit_page"
              type="blue"
              @click="goToJob(job.id)"
          >
            Go to Job
          </el-button>
        </el-form-item>
        <el-form-item v-else class="button_submit mb0">
          <el-button class="submit_page" type="grey" @click="goNext()">
           Log in to book
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {ElMessage} from "@/components/Vendor/Element";

import moment from "moment";

import {
  ref,
  onMounted,
  inject,
  nextTick, computed,
} from "vue";

import {addIcons} from "ionicons";
import {arrowBackOutline} from "ionicons/icons";

addIcons({
  "arrow-back-outline": arrowBackOutline,
});
import {
  IonToolbar,
  IonButton,
  IonButtons,
  IonIcon,
  IonTitle,
} from "@ionic/vue";

import {useStore} from "vuex";
import {
  useRouter,
} from "vue-router";
import formHooks from "@/hooks/form/form";
import formValidate from "@/hooks/form/validate/validate";
import { isAustraliaRegion } from '@/helpers/region/regionHelper.js';
import { messages } from "@/helpers/locales/locales";
import LocationIcon from "@/components/Icons/LocationIcon.vue";
import DollarWithCircleIcon from "@/components/Icons/DollarWithCircleIcon.vue";
import RoutingIcon from "@/components/Icons/RoutingIcon.vue";

import ClockIcon from "@/components/Icons/ClockIcon.vue";

export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    IonTitle,
    LocationIcon,
    DollarWithCircleIcon,
    ClockIcon,
    RoutingIcon
  },

  methods: {
    getTranslation(key) {      
      return this.isAustralia ? messages.AU[key] : messages.US[key];
    },
  },

  setup() {
    const $store = useStore();
    const $router = useRouter();
    const setPageClassGlobal = inject("setPageClassGlobal");
    const job = computed(() => {
      return $store.getters.getJobPreview;
    });

    let shifts = ref(job.value.shifts);
    const userData = $store.getters.GET_USER_DATA;
    const userRole = userData.role;
    const isAustralia = isAustraliaRegion();
    const message = inject('messages');

    shifts.value.forEach((shift) => {
      moment().diff(
          moment(shift.date + " " + shift.startTime, "YYYY/MM/DD HH:mm:ss"),
          "minutes"
      ) <= 0
          ? (shift.disabled = false)
          : (() => {
            shift.disabled = true;
            shift.checkboxValue = false;
          })();


      if (shift.userId) {
        shift.disabled = true;
        shift.checkboxValue = false;
      }

      if (shift.abilities) {
        const isAssignAvailable = shift.abilities["assign"] == true;

        shift.disabled = isAssignAvailable ? false : true;
        shift.checkboxValue = isAssignAvailable ? true : false;
      }

      if (shift.checkboxValue == undefined) {
        shift.checkboxValue = true;
      }
    });


    const formsDataArray = {
      dayForm: {
        jobShifts: {
          value: shifts,
          errors: null,
          validators: [
            {
              validator: (rule, formField, callback) => {
                let errors = formsData.dayForm.jobShifts.errors;
                let formName = formField.formName;
                if (!errors || !errors.length) {
                  setFormValidation(formName, rule.field, true);
                  callback();
                } else {
                  setFormValidation(formName, rule.field, false);
                  callback(new Error(""));
                }
              },
            },
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                    rule,
                    formField,
                    "jobShiftsBook",
                    callback,
                    setFormValidation
                );
              },
            },
          ],
        },
      },
    };



    const checkboxValueChange = () => {
      if (formsData.dayForm.jobShifts.errors) {
        delete formsData.dayForm.jobShifts.errors;
      }
      nextTick(() => {
        checkFormValidation("dayForm", true);
      });
    };

    const checkJobDateStart = (dateStart, endDate, trim) => {
      let start = moment(dateStart, "YYYY/MM/DD");
      let end = moment(endDate, "YYYY/MM/DD");
      if (start.format("MMMM") == end.format("MMMM")) {
        if (start.format("D") == end.format("D")) {
          return null;
        }
        return start.format("D ");
      } else {
        return start.format("D " + (trim ? "MMM" : "MMMM"));
      }
    };

    const getSelectedShiftsId = () => {
      return shifts.value
          .filter((day) => {
            if (day.checkboxValue == true) {
              return true;
            }
          })
          .map((day) => day.id);
    };

    const goBack = () => {
      $router.push({name: 'search'})
    };

    const goNext = () => {
      $router.push({
        name: "auth",
      });
    };

    const goToJob = (id) => {
      $router.push({
        name: "job_book_days",
        params: {
          jobId: id,
        },
      });
    }

    const submit = (formName) => {
      formsRefs[formName].value.validate((valid) => {
        if (valid) {
          (async () => {
            try {
              await $store.dispatch("SAVE_JOB_SHIFTS_LIST", {
                shifts_ids: getSelectedShiftsId(),
              });
              ElMessage({
                type: "success",
                message: "Thank You! Your booking has been confirmed.",
              });
              $router.push({
                name: "search",
              });
            } catch (error) {
              let errorMessage = [];
              shifts.value.filter((shift) => {
                let errorsArray = error.errors.some((element) => {
                  if (element.id == shift.id) {
                    errorMessage.push(
                        {
                          date: shift.date,
                          message: element.message,
                        }
                    );
                    return true;
                  }
                });
                if (!errorsArray) errorMessage.push(null);

              });
              console.log(errorMessage);
              formsData.dayForm.jobShifts.errors = errorMessage;
              checkFormValidation("dayForm", true);
            }
          })();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    };

    onMounted(() => {
      setPageClassGlobal("global_job_book_page global_job_preview_page");
      setFormRefs();
      checkFormValidation("dayForm", true);
    });

    const formatHourlyRate = (regularRate, weekendRate) => {
      let formattedString = "";

      formattedString += regularRate ? "$" + regularRate : "";
      formattedString += regularRate && weekendRate ? " - " : "";
      formattedString += weekendRate ? "$" + weekendRate : "";

      return formattedString;
    };

    const handleChange = (e) => {
      e.stoppropagation();
    };
    const confirmedHours = (confirmedHours, startTime, endTime) => {
      let hours = 0;
      if (confirmedHours == 0 || confirmedHours == null) {
        const start = moment(startTime, "HH:mm:ss");
        const end = moment(endTime, "HH:mm:ss");
        const duration = end.diff(start, 'minutes');
        let minutes = 0;

        hours = Math.floor(duration / 60);

        if (hours >= 1 && duration >= 60) {
          minutes = duration % 60;
        } else {
          minutes = duration
        }

        if (minutes) {
          if (minutes < 10) {
            minutes = '0' + minutes;
          }
          hours = hours + ":" + minutes;
        }

      } else {
        const string = String(confirmedHours)
        const numHours = string.split(".")[0];
        let minutes = string.split(".")[1];

        if (!minutes) {
          const time = numHours + ":" + "00";
          hours = String(time);
        } else {
          minutes = Number.parseFloat(`0.${minutes}`) * 60;
          hours = numHours + ":" + minutes.toFixed(0);
        }
      }

      return hours
    }






    const {

      checkFormValidation,
      setFormValidation,
      setFormRefs,
      formsData,
      formsRefs,
    } = formHooks(formsDataArray);

    return {
      formatHourlyRate,
      formsData,
      goToJob,
      handleChange,
      checkFormValidation,
      setFormValidation,
      goBack,
      goNext,
      submit,
      job,
      shifts,
      userRole,
      checkJobDateStart,
      checkboxValueChange,
      confirmedHours,
      userData,
      isAustralia,
      message
    };
  },
};
</script>
